<template>
  <div class="calculator">
    <h1>快速通道FSW Eligibility Criteria (factor points) 入池计分器</h1>
    
    <div class="section">
      <h2>语言 (最高28分)</h2>
      <div class="language-section">
        <div class="language-item">
          <label>Reading (CLB Level)</label>
          <select v-model="reading">
            <option v-for="n in 12" :key="n" :value="n">CLB {{ n }}</option>
          </select>
        </div>
        <div class="language-item">
          <label>Writing (CLB Level)</label>
          <select v-model="writing">
            <option v-for="n in 12" :key="n" :value="n">CLB {{ n }}</option>
          </select>
        </div>
        <div class="language-item">
          <label>Listening (CLB Level)</label>
          <select v-model="listening">
            <option v-for="n in 12" :key="n" :value="n">CLB {{ n }}</option>
          </select>
        </div>
        <div class="language-item">
          <label>Speaking (CLB Level)</label>
          <select v-model="speaking">
            <option v-for="n in 12" :key="n" :value="n">CLB {{ n }}</option>
          </select>
        </div>
      </div>
      <div class="result">语言得分: {{ languagePoints }}</div>
    </div>

    <div class="section">
      <h2>教育背景 (最高25分)</h2>
      <select v-model="education">
        <option value="0">未完成高中</option>
        <option value="5">高中毕业</option>
        <option value="15">一年制证书或文凭</option>
        <option value="19">两年制以上专科文凭</option>
        <option value="21">学士学位</option>
        <option value="23">两个以上学士学位</option>
        <option value="23">硕士学位</option>
        <option value="25">博士学位</option>
      </select>
      <div class="result">教育背景得分: {{ education }}</div>
    </div>

    <div class="section">
      <h2>工作经验 (最高15分)</h2>
      <select v-model="experience">
        <option value="0">1年以下</option>
        <option value="9">1年</option>
        <option value="11">2-3年</option>
        <option value="13">4-5年</option>
        <option value="15">6年以上</option>
      </select>
      <div class="result">工作经验得分: {{ experience }}</div>
    </div>

    <div class="section">
      <h2>年龄 (最高12分)</h2>
      <select v-model="age">
        <option value="0">17岁以下或45岁以上</option>
        <option value="12">18-35岁</option>
        <option value="11">36岁</option>
        <option value="10">37岁</option>
        <option value="9">38岁</option>
        <option value="8">39岁</option>
        <option value="7">40岁</option>
        <option value="6">41岁</option>
        <option value="5">42岁</option>
        <option value="4">43岁</option>
        <option value="3">44岁</option>
      </select>
      <div class="result">年龄得分: {{ age }}</div>
    </div>

    <div class="section">
      <h2>加拿大工作安排 (最高10分)</h2>
      <select v-model="arrangement">
        <option value="0">无</option>
        <option value="10">有LMIA支持的工作offer</option>
      </select>
      <div class="result">工作安排得分: {{ arrangement }}</div>
    </div>

    <div class="section">
      <h2>适应能力 (最高10分)</h2>
      <div class="adaptability-items">
        <div class="adaptability-item">
          <label>
            <input type="checkbox" v-model="adaptabilityFactors.spouse">
            配偶语言水平达到CLB 4或以上
          </label>
        </div>
        <div class="adaptability-item">
          <label>
            <input type="checkbox" v-model="adaptabilityFactors.education">
            在加拿大完成至少两年的全日制学习
          </label>
        </div>
        <div class="adaptability-item">
          <label>
            <input type="checkbox" v-model="adaptabilityFactors.work">
            在加拿大工作至少一年
          </label>
        </div>
        <div class="adaptability-item">
          <label>
            <input type="checkbox" v-model="adaptabilityFactors.relative">
            在加拿大有亲属关系
          </label>
        </div>
      </div>
      <div class="result">适应能力得分: {{ adaptabilityPoints }}</div>
    </div>

    <div class="total-score">
      <h2>总分: {{ totalPoints }}/100</h2>
      <div class="pass-status" :class="{ pass: totalPoints >= 67 }">
        {{ totalPoints >= 67 ? '恭喜！达到入池分数' : '未达到入池分数' }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FSWCalculatorView',
  data() {
    return {
      reading: 7,
      writing: 7,
      listening: 7,
      speaking: 7,
      education: '21',
      experience: '9',
      age: '12',
      arrangement: '0',
      adaptabilityFactors: {
        spouse: false,
        education: false,
        work: false,
        relative: false
      }
    }
  },
  computed: {
    languagePoints() {
      const getPoints = (level) => {
        if (level >= 9) return 7;
        if (level >= 8) return 6;
        if (level >= 7) return 5;
        if (level >= 6) return 3;
        if (level >= 5) return 1;
        return 0;
      };
      return getPoints(this.reading) + getPoints(this.writing) + 
             getPoints(this.listening) + getPoints(this.speaking);
    },
    adaptabilityPoints() {
      let points = 0;
      if (this.adaptabilityFactors.spouse) points += 5;
      if (this.adaptabilityFactors.education) points += 5;
      if (this.adaptabilityFactors.work) points += 10;
      if (this.adaptabilityFactors.relative) points += 5;
      return Math.min(points, 10);
    },
    totalPoints() {
      return this.languagePoints + Number(this.education) + 
             Number(this.experience) + Number(this.age) + 
             Number(this.arrangement) + this.adaptabilityPoints;
    }
  }
}
</script>

<style scoped>
.calculator {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

h1 {
  text-align: center;
  color: #333;
  margin-bottom: 30px;
}

.section {
  background: #f5f5f5;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
}

h2 {
  color: #444;
  margin-bottom: 15px;
}

.language-section {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
}

.language-item {
  display: flex;
  flex-direction: column;
}

select {
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-top: 5px;
}

.result {
  margin-top: 10px;
  font-weight: bold;
  color: #2c3e50;
}

.adaptability-items {
  display: grid;
  gap: 10px;
}

.adaptability-item {
  display: flex;
  align-items: center;
}

.adaptability-item input[type="checkbox"] {
  margin-right: 10px;
}

.total-score {
  text-align: center;
  background: #e8f5e9;
  padding: 20px;
  border-radius: 8px;
  margin-top: 30px;
}

.pass-status {
  margin-top: 10px;
  font-weight: bold;
  color: #d32f2f;
}

.pass-status.pass {
  color: #2e7d32;
}
</style>